<h3 class="secrets-header">
  <span>Secrets</span>
  <capra-button
    text="New secret"
    data-test="create-secret-cta"
    variant="secondary"
    size="small"
    color="neutral"
    icon="illo-lock-green"
    (click)="createSecret()"
  >
  </capra-button>
</h3>

<p class="notebook-sidebar-text" [ngClass]="{ 'notebook-secure-border': (isSecretsExist$ | async) }">
  Add secure variables here. Secrets can be managed by members with edit access to this Report.
  <a target="_blank" href="https://mode.com/help/articles/notebook#python-notebooks-secrets-store">Learn more</a>
</p>

<div class="notebook-secure-creds">
  <ul class="notebook-secrets">
    <li
      *ngFor="let secret of secrets$ | async; trackBy: trackByFn"
      [ngClass]="{ active: getActive(secret) }"
      [data-test-token]="secret.token"
    >
      <div
        class="secret secret-key"
        capraTooltip
        [tooltipContent]="secret.key"
        tooltipPlacement="top-start"
        tooltipSize="mini"
      >
        <capra-icon icon="icon-lock-secret"></capra-icon>
        <span>{{ secret.key }}</span>
      </div>
      <mode-secret-row-button
        [secret]="secret"
        (editSecret)="editSecret($event)"
        (deleteSecret)="deleteSecret($event)"
        (handleDialogOpen)="handleDialogOpen($event)"
      >
      </mode-secret-row-button>
    </li>
  </ul>
</div>
